import styled from 'styled-components'
import { useState,useEffect } from 'react'



const Container=styled.div`

	display:flex;
	justify-content:center;
	align-items:center;
	height:100%;
	width:100%;
	
	
	

  `;

const Presentacion = styled.div`
  height:100%;
  width:100%;
     
  
  
`;
export default function PreviewVideo(props){
	let { url }=props;
	let [videoUrl,setVideoUrl]=useState(url);

	useEffect(()=>{ setVideoUrl(url)},[url])
	

	return(
		<Container>
			{url?<Presentacion>
					<iframe 
						width="100%" 
						height="100%" 
						src={`${videoUrl}`} 
						title="YouTube video player" 
						frameBorder="0" 
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
						referrerpolicy="strict-origin-when-cross-origin" allowFullScreen>					
					</iframe>

				</Presentacion>:null}
			
		</Container>)
}